<template>
  <div class="copyright">
    <a href="https://beian.miit.gov.cn/">
      <p>Copyright @2022 客维智能科技（广州）有限公司 版权所有</p>
      <p>粤ICP备11053761号-5</p>
    </a>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.copyright {
  font-size: 12px;
  text-align: center;
  margin-bottom: 1.3rem;
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
